import { supabase } from '@/integrations/supabase/client';

/**
 * Fire-and-forget feature event tracking for UX telemetry.
 * Never blocks UI, never throws. Silent on failure.
 *
 * @param feature - Feature identifier ('oreja' | 'meeting_analysis')
 * @param event - Event name (e.g., 'session_started')
 * @param metadata - Optional event metadata
 */
export function trackFeatureEvent(
  feature: string,
  event: string,
  metadata: Record<string, unknown> = {},
): void {
  supabase
    .from('feature_events')
    .insert({ feature, event, metadata })
    .then();
}

/** Typed event name constants to prevent typos */
export const FeatureEvent = {
  OREJA: {
    SESSION_STARTED: 'session_started',
    PHASE_ENTERED: 'phase_entered',
    CLARIFICATION_SKIPPED: 'clarification_skipped',
    PROPOSALS_REVIEWED: 'proposals_reviewed',
    SESSION_COMMITTED: 'session_committed',
    SESSION_ABANDONED: 'session_abandoned',
  },
  MEETING: {
    ANALYSIS_STARTED: 'analysis_started',
    ANALYSIS_COMPLETED: 'analysis_completed',
    REVIEW_STARTED: 'review_started',
    TASKS_PUSHED: 'tasks_pushed',
    REVIEW_PENDING_AGE: 'review_pending_age',
  },
} as const;
